<script>
export default {
    name: 'IconEnfant'
}
</script>
<template>
    <svg
        class="base-icon icon-enfant"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="currentColor" fill-rule="evenodd">
            <path
                d="M23 28c8.446 0 15.596 5.886 18 14-2.404 8.114-9.554 14-18 14S7.404 50.114 5 42c2.403-8.114 9.553-14 18-14zm.254-20a7.8 7.8 0 110 15.6 7.8 7.8 0 010-15.6z"
            />
            <path
                d="M43.5 34.333c5.865 0 10.83 3.924 12.5 9.333C54.33 49.076 49.365 53 43.5 53c-5.866 0-10.83-3.924-12.5-9.333 1.67-5.41 6.634-9.334 12.5-9.334zM43.5 21l10.476 3.999.004.001v6.709c.565.148.982.67.982 1.291 0 .736-.586 1.333-1.31 1.333-.723 0-1.31-.597-1.31-1.333 0-.621.417-1.143.982-1.291V25.25l-4.623 1.765a5.1 5.1 0 01.034.432l.005.22c0 2.945-2.346 5.333-5.24 5.333s-5.24-2.388-5.24-5.333c0-.22.013-.438.039-.652L33.02 25l10.48-4z"
            />
        </g>
    </svg>
</template>
